import { Flex } from '@chakra-ui/react';
import { Logo } from '@morressier/alembic';
import {
  IBrandLayoutProps
} from 'src/contexts/BrandConfigProvider';
import { ClientBrand } from '../../routes/AuthRealmAccessControl/AuthRealmContext';

export const twoColumnBrandLayout =
  (brandConfig: ClientBrand) =>
  ({ children }: IBrandLayoutProps) =>
    (
      <Flex
        width="100%"
        minHeight="100dvh"
        padding={{ base: 4, md: 8 }}
        gap={{ base: 6, md: 8 }}
        direction={{ base: 'column', lg: 'row' }}
      >
        {/* ----- Left Column ----- */}
        <Flex
          height={{ base: 'auto', lg: '100%' }}
          flexGrow={1}
          flexBasis={0}
          width={{ base: '100%', lg: 'auto' }}
          justifyContent="center"
        >
          <Flex
            flexDirection="column"
            gap={{ base: 6, md: 10, lg: 12 }}
            width="100%"
            maxWidth={{ base: '100%', md: '720px', lg: '560px' }}
          >
            <Logo
              src={brandConfig.logoUrl}
              alt={`${brandConfig.name} logo`}
              width={{ base: '140px', md: '173px' }}
            />
            <Flex flexDirection="column" gap={{ base: 3, md: 4 }}>
              {children}
            </Flex>
          </Flex>
        </Flex>
        {/* ----- Right Column ----- */}
        <Flex
          height={{ base: '220px', md: '320px', lg: '100%' }}
          minHeight={{ lg: '520px' }}
          flexGrow={2}
          flexBasis={0}
          width={{ base: '100%', lg: 'auto' }}
        >
          <Flex
            backgroundImage={
              brandConfig.footerUrl.startsWith('url(')
                ? brandConfig.footerUrl
                : `url(${brandConfig.footerUrl})`
            }
            backgroundSize="cover"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            borderRadius={{ base: 'md', md: 'lg' }}
            width="100%"
            height="100%"
          />
        </Flex>
      </Flex>
    );
